import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from './useAnalytics';

/**
 * Tracks scroll depth on the current page.
 * Fires when user scrolls to 25%, 50%, 75%, and 100% of page height.
 */
export function useScrollTracking(): void {
  const location = useLocation();
  const trackedDepths = new Set<number>();

  useEffect(() => {
    const trackScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      const scrollPercent = Math.round(
        ((scrollTop + windowHeight) / documentHeight) * 100
      );

      // Track at 25%, 50%, 75%, and 100%
      [25, 50, 75, 100].forEach((threshold) => {
        if (scrollPercent >= threshold && !trackedDepths.has(threshold)) {
          trackedDepths.add(threshold);
          analytics.trackScrollDepth(location.pathname, threshold);
        }
      });
    };

    window.addEventListener('scroll', trackScroll, { passive: true });
    return () => window.removeEventListener('scroll', trackScroll);
  }, [location.pathname]);
}
